import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    letrex: null,
    hasChanges: false,
  },
  mutations: {
    setLetrex(state, letrex) {
      state.letrex = letrex;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setLetrex({ commit }, model) {
      commit('setLetrex', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getLetrex({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setLetrex', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-letrex-list');
        });
    },
  },
};
